// Written by desktop/scripts/stamp-version.js. Do not edit by hand.
export const VERSION = "0.9.241";
export const BUILT_AT = "4 nov 13:36";
export const BUILT_AT_ISO = "2026-11-04T12:36:20.007Z";
